import { render, staticRenderFns } from "./draggableitem.vue?vue&type=template&id=292af489&scoped=true"
import script from "./draggableitem.vue?vue&type=script&lang=ts"
export * from "./draggableitem.vue?vue&type=script&lang=ts"
import style0 from "./draggableitem.vue?vue&type=style&index=0&id=292af489&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292af489",
  null
  
)

export default component.exports